// @ts-ignore

import React, { ReactChildren, ReactChild, useEffect, useState, useContext } from 'react';
import { Box, useMediaQuery } from '@mui/material';
import cn from 'classnames';
import Footer from '../Footer/Footer';
import Header from '../Header/Header';
import { makeStyles } from '@mui/styles';
import { APISideBarNavigation, SideBarNavigation } from '../SideBarNavigation';
import { Theme } from '@mui/material/styles';
import { MainMenu } from '../MainMenu/MainMenu';
import { MainMenuMobile } from '../MainMenu/MainMenuMobile';
import { lighten } from '@mui/material/styles';
import { useLocation } from 'react-router-dom';

export interface Props {
  title?: string;
  showHeader?: boolean;
  showFooter?: boolean;
  showSidebarNav?: boolean;
  showAPISidebarNav?: boolean;
  elevated?: boolean;
  showPaddingTop?: boolean;
  admin?: boolean;
  className?: string;
  children?: ReactChild | ReactChildren;
  showMainMenu?: boolean;
  onHoverExpand?: boolean;
}

const useStyles = makeStyles<Theme, { isSidebarOpen: boolean; showMainMenu: boolean; isMobile: boolean }>((theme) => ({
  root: {
    display: 'flex',
    width: '100%',
    minHeight: '100vh',
    backgroundColor: theme.palette.background.default,
  },
  screenPaddingOn: {
    padding: 16,
    '@media print': {
      padding: 0,
    },
  },
  screenPaddingOff: {
    paddingLeft: 0,
    paddingRight: 0,
  },
  elevatedBox: {
    paddingTop: theme.spacing(2),
    backgroundColor: '#ff0044',
    [theme.breakpoints.up('lg')]: {
      paddingTop: theme.spacing(5),
    },
  },
  childrenBox: {
    minHeight: '75vh', // @ts-ignore
    background: theme.palette.common.background,
  },
  childrenBoxAdmin: {
    marginLeft: '0vh',
    minHeight: '100vh', // @ts-ignore
    minWidth: '-webkit-fill-available', // @ts-ignore
    background: theme.palette.admin.background,
    [theme.breakpoints.down('sm')]: {
      width: '80vw',
    },
  },
  screenWithSidebar: {
    paddingLeft: ({ isSidebarOpen, showMainMenu, isMobile }) =>
      isMobile ? 0 : showMainMenu ? (isSidebarOpen ? 240 : 70) : 0,
    // background: '#f5f5f5',
    background: '#FFFFFF',
    '@media print': {
      marginLeft: 0,
    },
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 0,
      // background: '#f5f5f5',
      background: '#FFFFFF',
    },
  },
  screenWithSidebarAdmin: {
    paddingLeft: ({ isSidebarOpen, showMainMenu, isMobile }) =>
      isMobile ? 0 : showMainMenu ? (isSidebarOpen ? 240 : 70) : 0,
    background: lighten('#211551', 0.95),
    transition: 'padding-left 300ms ease',
    '@media print': {
      marginLeft: 0,
    },
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 0,
      background: lighten('#211551', 0.95),
    },
  },
  screenWithAPISidebar: {
    marginLeft: ({ isMobile }) => (isMobile ? 0 : 250),
    '@media print': {
      marginLeft: 0,
    },
  },
}));

const Screen = ({
  title,
  showHeader,
  showFooter,
  showSidebarNav,
  showAPISidebarNav,
  children,
  className,
  elevated = true,
  showPaddingTop = true,
  admin,
  showMainMenu = true,
  onHoverExpand = true,
}: Props) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(() => {
    const savedMenuState = localStorage.getItem('menuOpen');
    return savedMenuState !== null ? JSON.parse(savedMenuState) : true;
  });
  const isMobile = useMediaQuery('(max-width: 768px)');
  const classes = useStyles({ isSidebarOpen, showMainMenu, isMobile });
  const location = useLocation();

  useEffect(() => {
    // console.log('Location changed:', location.pathname);
    // Additional logic on location change
  }, [location]);

  // console.log('admin: ', admin)
  // console.log('showSidebarNav: ', showSidebarNav)
  // console.log('showAPISidebarNav: ', showAPISidebarNav)
  return (
    <Box
      className={cn(
        admin
          ? classes.screenWithSidebarAdmin
          : showSidebarNav
          ? classes.screenWithSidebar
          : showAPISidebarNav
          ? classes.screenWithAPISidebar
          : '',
      )}
      style={{ minHeight: '100vh', width: '100%' }}
    >
      {showHeader && <Header title={title} />}

      {showMainMenu &&
        (isMobile ? (
          <MainMenuMobile
            openMenu={isSidebarOpen}
            setIsSidebarOpen={setIsSidebarOpen}
          />
        ) : (
          <MainMenu
            openMenu={isSidebarOpen}
            setIsSidebarOpen={setIsSidebarOpen}
            onHoverExpand={onHoverExpand}
          />
        ))}

      <Box
        className={cn(
          elevated ? classes.screenPaddingOn : classes.screenPaddingOff,
          showPaddingTop && classes.elevatedBox,
          admin ? classes.childrenBoxAdmin : classes.childrenBox,
          className,
        )}
        style={{
          paddingBottom: 150,
          marginTop: isMobile ? 64 : 0,
        }}
      >
        {children}
      </Box>
      {showFooter && <Footer />}
    </Box>
  );
};

export default Screen;
